export { createTenderDetailsRoute } from './details';
export { createTenderContractsRoute } from './contracts';
export { createTenderSuppliersRoute } from './suppliers';
export { createTenderReviewRoute } from './review';
